import { mapState } from 'vuex';
import dataSourcesDataMixin from './dataSourcesDataMixin';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicOriginatorsTypeSelector',
  mixins: [formMixin, dataSourcesDataMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  },
  watch: {},
  created() {
    this.formItem = cloneDeep(this.editedItem);
  },
  methods: {
    selectedType(type) {
      this.$emit('type-selected', type);
    }
  }
};